export default {
	OPEN_ACTIVITY: "OPEN_ACTIVITY",
	SHOW_MESSAGE: "SHOW_MESSAGE"
};
